import { useContext, useEffect } from "react"
import { Field, useFormikContext } from "formik"
import _ from "lodash"

import { FormContext } from "../../../context/formContext"
import { Dropdown } from "primereact/dropdown"

import styles from "../../../styles/Form.module.css"
import fieldVisibility from "../../../helpers/fieldVisibility"


export default function ParticipantPhonePrimaryNone({ field, block, index }) {
  const form = useContext(FormContext)
  const formik = useFormikContext()
  const options = field.field_options

  let isDisabled = form ? form.blocksSaved[block] : false
  isDisabled = field.read_only ? true : isDisabled

  const checkIfRequired = () => {
    try {
      return JSON.parse(field.field_validation.required[0])
    } catch (error) {
      return false
    }
  }

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    const value = formik.values.participant_phone_primary_none

    if (_.isUndefined(value) || value === "Yes" || (_.isArray(value) && value[0] !== "Yes")) {
      formik.setFieldValue(field.field_name, "Yes")
    } else if (value === "No" || (_.isArray(value) && value[0] === "Yes")) {
      formik.setFieldValue(field.field_name, "No")
    }

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps, no-sparse-arrays
  }, [])

  const isRequired = checkIfRequired()

  return (
    <div
      className={styles.field}
      style={{
        order: index,
        display: fieldVisibility(field.field_visibility),
      }}
    >
      <label className={styles.label}>
        {field.field_label}
        {isRequired && "*"}
      </label>
      {field.field_description && (
        <div className={styles.description}>{field.field_description}</div>
      )}
      <div className={styles.value}>
        <Field name={field.field_name}>
          {({ field: formikField, meta }) => {
            return (
              <>
                <Dropdown
                  placeholder="Please select"
                  name={formikField.name}
                  value={formikField.value}
                  onChange={formikField.onChange}
                  disabled={isDisabled}
                  options={options}
                />
                {meta.touched && meta.error && (
                  <div className={styles.errFieldMsg}>{meta.error}</div>
                )}
              </>
            )
          }}
        </Field>
      </div>
    </div>
  )
}